import React from "react";
import { useGlobal, useState, useEffect } from "reactn";
import { Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { env } from "../app.config"
import Cookies from 'js-cookie';
import { useHistory } from "react-router";
import firebaseDb, { auth } from '../firebase';
import { collection, query, where, getDocs, setDoc, doc } from 'firebase/firestore';
import jwt from 'jsonwebtoken';
import { signInWithEmailAndPassword } from "firebase/auth";

let jwtsecret = env.JWT_SECRET;

const Login = (props) => {
  let [, setToken] = useGlobal("token");
  let [, setUser] = useGlobal("user");
  let history = useHistory()

  const admin = async ({ username, password }) => {
    await signInWithEmailAndPassword(auth, username, password).then(async (userCredential) => {
      const adminRef = collection(firebaseDb, 'users');
      const adminQuery = query(adminRef, where("uuid", "==", userCredential.user.uid), where("role", "==", "admin"));
      const adminSnapshot = await getDocs(adminQuery);
      const adminList = adminSnapshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() }
      });

      if (adminList.length < 1) {
        alert('Password or Username is incorrect');
      }
      else {
        token(adminList[0])
      }
    }).catch((e) => {
      alert('Password or Username is incorrect');
    })
  }

  const token = async (admin) => {
    let token = jwt.sign(admin, jwtsecret);

    await setDoc(doc(firebaseDb, "admin", admin.id), {
      ...admin,
      token: token,
    });

    setToken(token);
    setUser({
      ...admin,
      token: token
    });

    localStorage.setItem("user", JSON.stringify({
      ...admin,
      token: token
    }));
    Cookies.set("user", {
      ...admin,
      token: token
    })
    Cookies.set("token", token)
    props.history.push("/questionSet");
  }

  const onFinish = (values) => {
    admin(values);
  };

  return (
    <div className="login-wrap">
      <div className="form">
        < Form
          name="normal_login"
          className="login-form"
          size="large"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <div className="logo"></div>
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: 'Please input your Username!',
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="E-Posta"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: 'Please input your Password!',
              },
            ]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Sifre"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="light"
              htmlType="submit"
              className="login-form-button"
              id="1"
            >
              Giriş yap
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div >
  );
};

export default Login;
